import { Group } from '@sparx/api/apis/sparx/teacherportal/groupsapi/v1/groupsapi';

export const getStudentGroupId = (group: Group) => group.name.split('/studentGroups/')[1];
